import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import { EntityMediaFragmentDoc } from '../../../../../../../features/messages/graphql/fragments/generated/MediaType';
import { MgsaEntityFragmentDoc } from '../../../../../../org-hierarchy/modules/org-roles/views/UserRoleDetailsTabView/graphql/fragments/generated/MgsaEntityFragment';
export type LearnerProfileDetailsFragment = { status: Types.UserStatusEnum, emailId?: string | null, uniqueId: string, createdAt: string, deletedAt?: string | null, isStaff: boolean, isManager: boolean, lastActiveAt?: string | null, hierarchyPathUpdatedAt?: string | null, hierarchyPath?: string | null, timezone?: string | null, id: string, name?: string | null, firstName?: string | null, profilePicture?: string | null, cover?: { name: string, description?: string | null, url?: string | null, size?: number | null, mimeType?: string | null, mediaId: string, kind: Types.MediaKindEnum, resolutions?: Array<{ type: Types.ResolutionEnum, url: string }> | null } | null, socials?: Array<{ type: Types.UserSocialAccountTypeEnum, link: string }> | null, mgsaEntity?: { id: string, entityType: Types.MgsaEntityTypeEnum, entityId: string, mindsetCount?: number | null, skillCount?: number | null, goalsSummary?: string | null, resolvedGoals?: Array<{ id: string, name: string }> | null, activities?: Array<{ description?: string | null, activityType: Types.MgsaActivityTypeEnum, activityEntityId?: string | null }> | null, mindsets?: Array<{ id: string, name: string, description?: string | null, attachedToEntitiesCount?: { contentsCount: number, okrsCount: number, tasksCount: number } | null }> | null, skillGroupConfigs?: Array<{ skillGroupName: string, skillConfig: Array<{ expectedScore: number, reviewerScore: number, score?: number | null, skillId: string, skills?: { id: string, name: string, attachedToEntitiesCount?: { contentsCount: number, okrsCount: number, tasksCount: number } | null } | null }> }> | null } | null, department?: { id: string, name: string } | null, orgRole?: { id: string, name: string } | null, manager?: { id: string } | null, responsibilities?: Array<{ id: string }> | null, userSkillScores?: Array<{ id: string, isMgsaAffected: boolean, score: number, userId: string, entityId: string }> | null };


export type LearnerProfileDetailsFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const LearnerProfileDetailsFragmentDoc = /*#__PURE__*/ gql`
    fragment LearnerProfileDetails on UserType {
  ...User
  cover {
    ...EntityMedia
  }
  socials {
    type
    link
  }
  mgsaEntity {
    ...MgsaEntityFragment
  }
  status
  emailId
  uniqueId
  createdAt
  deletedAt
  isStaff
  isManager
  lastActiveAt
  department {
    id
    name
  }
  orgRole {
    id
    name
  }
  manager {
    id
  }
  hierarchyPathUpdatedAt
  hierarchyPath
  timezone
  responsibilities {
    id
  }
  userSkillScores {
    id
    isMgsaAffected
    score
    userId
    entityId
  }
}
    `;